import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, Autocomplete, Stack} from 'views/components';

import {Translate, translate} from 'views/module';

import CareviewTypes from './careview_types';

const CareViewItemNew = (props) => {
  const [isAdding, setIsAdding] = React.useState(false);
  const [careviewItem, setCareviewItem] = React.useState(null);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);

  const addQuestion = props.addQuestion;
  const close = props.close;

  // Update the save button's disabled state
  React.useEffect(() => {
    if (!careviewItem) {
      setIsSaveDisabled(true);
      return;
    }
    if (!careviewItem.questionData.questionTitle.trim().length) {
      setIsSaveDisabled(true);
      return;
    }
    if (careviewItem.type === 'MULTIPLE_CHOICE') {
      const options = careviewItem.questionData.options
          .filter((e) => e?.optionTitle?.trim().length);
      if (options.length < 2) {
        setIsSaveDisabled(true);
        return;
      }
    }
    setIsSaveDisabled(false);
  }, [careviewItem]);

  const onTypeChange = (newType) => {
    if (newType === 'FIVE_STAR') {
      setCareviewItem({
        type: newType,
        questionData: {
          questionTitle: '',
        },
      });
    } else if (newType === 'FREE_FORM_TEXT') {
      setCareviewItem({
        type: newType,
        questionData: {
          questionTitle: '',
        },
      });
    } else if (newType === 'MULTIPLE_CHOICE') {
      setCareviewItem({
        type: newType,
        questionData: {
          questionTitle: '',
          options: [{}, {}],
        },
      });
    } else if (newType === 'YES_NO') {
      setCareviewItem({
        type: newType,
        questionData: {
          questionTitle: '',
          followUpYesNo: {
            enabledOnYes: false,
            enabledOnNo: false,
          },
        },
      });
    }
  };

  const updateQuestionData = (callBack) => {
    setCareviewItem((e) => {
      return {
        ...e,
        questionData: callBack(e.questionData),
      };
    });
  };

  const submit = () => {
    setIsAdding(true);
    const type = careviewItem.type;
    const questionData = careviewItem.questionData;

    if (type === 'MULTIPLE_CHOICE') {
      questionData.options = questionData.options
          .filter((e) => e?.optionTitle?.trim().length)
          .map((e) => {
            if (e.followUp === undefined) {
              e.followUp = false;
            }
            return e;
          });
    }
    addQuestion(type, questionData, () => close() );
  };


  const CareviewType = CareviewTypes[careviewItem?.type];

  const optionList = [
    {
      label: translate('client.ClientDetail.CareviewSettings.Types.FiveStar.Title'),
      key: 'FIVE_STAR',
    },
    {
      label: translate('client.ClientDetail.CareviewSettings.Types.FreeFormText.Title'),
      key: 'FREE_FORM_TEXT',
    },
    {
      label: translate('client.ClientDetail.CareviewSettings.Types.YesNo.Title'),
      key: 'YES_NO',
    },
    {
      label: translate('client.ClientDetail.CareviewSettings.Types.MultipleChoice.Title'),
      key: 'MULTIPLE_CHOICE',
    },
  ];

  return (
    <Dialog onClose={() => close()}>
      <DialogTitle onClose={() => close()}>
        <Translate
          expression='client.ClientDetail.CareviewSettings.NewQuestion.Title'
        />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            p: 1,
          }}
          spacing={2}
        >
          <Autocomplete
            label={translate('client.ClientDetail.CareviewSettings.NewQuestion.SelectType')}
            options={optionList}
            getOptionLabel={(option) => option.label}
            onChange={(newValue) => onTypeChange(newValue.key) }
            sx={{minWidth: {xs: '192px', md: '256px'}}}
            disableClearable
          />
          {
            CareviewType &&
            <CareviewType.ContentNew
              careviewItem={careviewItem}
              setCareviewItem={updateQuestionData}
            />
          }
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={() => close()}>
          <Translate expression='generic.Cancel'/>
        </Button>
        <Button onClick={submit} loading={isAdding} disabled={isSaveDisabled}>
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CareViewItemNew.propTypes = {
  addQuestion: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};
export default React.memo(CareViewItemNew);
